import { __decorate } from "tslib";
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
/**
 * @param Base The base class.
 * @returns Radio component.
 */
export class Checkitem extends CipublicElement {
    constructor() {
        super(...arguments);
        /**
         * Sets the element to be focused automatically on page load. Defaults to `false`.
         */
        this.autofocus = false;
        /**
         * `true` if element should be checked.
         */
        this.checked = false;
        /**
         * Indicate if the element is disabled. Defaults to `false`.
         */
        this.disabled = false;
    }
}
__decorate([
    property({ reflect: true, type: Boolean })
], Checkitem.prototype, "autofocus", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], Checkitem.prototype, "checked", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], Checkitem.prototype, "disabled", void 0);
__decorate([
    property({ reflect: true })
], Checkitem.prototype, "value", void 0);
//# sourceMappingURL=checkitem.js.map